"use strict";
//港股合规,跳转到单页提示
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HKGotoTip = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
function HKGotoTip(props) {
    return (0, react_dom_1.createPortal)(react_1.default.createElement("div", { id: "hkgototip" },
        react_1.default.createElement("div", { className: "shadow", onClick: props.onClose }),
        react_1.default.createElement("div", { className: "tip" },
            react_1.default.createElement("div", { className: "close", onClick: props.onClose }, "x"),
            react_1.default.createElement("div", { className: "t" }, "\u63D0\u793A"),
            react_1.default.createElement("div", { className: "b" },
                "\u6839\u636E\u9999\u6E2F\u4EA4\u6613\u6240\u8D44\u8BAF\u670D\u52A1\u6709\u9650\u516C\u53F8\u89C4\u5B9A\uFF0C",
                react_1.default.createElement("br", null),
                "\u6E2F\u80A1\u5B9E\u9645\u57FA\u672C\u62A5\u4EF7\u670D\u52A1\u53EA\u53EF\u5728\u4E1C\u65B9\u8D22\u5BCC\u7AD9\u5185\u641C\u7D22\u6216\u8005\u8DF3\u8F6C\u8FDB\u884C\u67E5\u770B"),
            react_1.default.createElement("div", { className: "btnd" },
                react_1.default.createElement("a", { href: props.gotolink, target: "_self", className: "gotolink" }, "\u8DF3\u8F6C\u67E5\u770B")))), document.body);
}
exports.HKGotoTip = HKGotoTip;
